import { AuthenticationDetails, CognitoAccessToken, CognitoIdToken, CognitoRefreshToken, CognitoUser, CognitoUserAttribute, CognitoUserSession } from 'amazon-cognito-identity-js';
import businesspool from './pools/businesspool';
import userpool from './pools/userpool';
import { getUserPool } from './pools/pools';
import { setAuth, clearAuth, getAuth } from '../contexts/authStore';

export const checkAccessLevel = (accessLevel: string | null) => {
    if (accessLevel && (accessLevel === "manager" || accessLevel === "admin")) {
        return true
    } else {
        return false
    }
}

export const getAppsyncUrl = () => {
    if (getUserPool()!.getUserPoolName() === "divUljyGu") {
        return APPSYNC_API_URL;
    } else {
        return APPSYNC_API_URL + "u";
    }
}

export const APPSYNC_API_URL = "https://stqnklj29l.execute-api.us-east-1.amazonaws.com/graphql";

export const authenticateBusiness = (userId: string, Password?: string) => {
    return new Promise((resolve, reject) => {
        const user = new CognitoUser({
            Username: userId,
            Pool: businesspool
        });

        const authDetails = new AuthenticationDetails({
            Username: userId,
            Password
        });

        user.authenticateUser(authDetails, {
            onSuccess: (result) => {
                user.getUserAttributes((err, attributes) => {
                    if (err) {

                    } else {
                        attributes?.map((attr) => {
                            if (attr.getName() === 'custom:user_type') {
                                setAuth({ user_type: attr.getValue() } as any);
                            } else if (attr.getName() === 'email_verified') {
                                setAuth({ email_verified: attr.getValue().toString() } as any);
                            } else if (attr.getName() === 'phone_number_verified') {
                                setAuth({ phone_number_verified: attr.getValue().toString() } as any);
                            } else if (attr.getName() === 'custom:role') {
                                setAuth({ role: attr.getValue() } as any);
                            }
                        });
                    }
                });
                setAuth({
                    userId, name: result.getIdToken().payload.name,
                    accessToken: result.getAccessToken().getJwtToken(),
                    idToken: result.getIdToken().getJwtToken(),
                    refreshToken: result.getRefreshToken().getToken(),
                    expiry: result.getAccessToken().getExpiration() * 1000,
                    refreshExpiry: result.getAccessToken().getExpiration() * 1000 + 3600000
                } as any);
                resolve(result);
            },
            onFailure: (err) => {
                reject(err);
            },
            newPasswordRequired: () => {
                user.completeNewPasswordChallenge(Password!, null, {
                    onFailure: (err: any) => {
                        reject(err);
                    },
                    onSuccess: (result: any) => {
                        resolve(result);
                    }
                });
            }
        });
    });
};

export const authenticateBusinessExternal = (userId: string, access_token: string, id_token: string, refresh_token: string) => {
    return new Promise((resolve, reject) => {
        const cognitoSession = new CognitoUserSession({
                AccessToken: new CognitoAccessToken({ AccessToken: access_token }),
                IdToken: new CognitoIdToken({ IdToken: id_token }),
                RefreshToken: new CognitoRefreshToken({ RefreshToken: refresh_token })
            });


        
        const cognitoUser = new CognitoUser({
            Username: userId,
            Pool: businesspool
        });
        
        cognitoUser.setSignInUserSession(cognitoSession);
        cognitoUser.getUserAttributes((err: any, attributes?: CognitoUserAttribute[]) => {
            if (err) {
                reject(err);
            } else {   
                attributes?.map((attr: CognitoUserAttribute) => {
                    if (attr.getName() === 'custom:user_type') {
                        setAuth({ user_type: attr.getValue() } as any);
                    } else if (attr.getName() === 'email_verified') {
                        setAuth({ email_verified: attr.getValue().toString() } as any);
                    } else if (attr.getName() === 'phone_number_verified') {
                        setAuth({ phone_number_verified: attr.getValue().toString() } as any);
                    } else if (attr.getName() === 'custom:role') {
                        setAuth({ role: attr.getValue() } as any);
                    }
                });
                setAuth({
                    userId, name: cognitoSession.getIdToken().payload.name,
                    accessToken: cognitoSession.getAccessToken().getJwtToken(),
                    idToken: cognitoSession.getIdToken().getJwtToken(),
                    refreshToken: cognitoSession.getRefreshToken().getToken(),
                    expiry: cognitoSession.getAccessToken().getExpiration() * 1000,
                    refreshExpiry: cognitoSession.getAccessToken().getExpiration() * 1000 + 3600000
                } as any);
                resolve(cognitoSession);
            }
        });
    });
};

export const authenticateUsers = (userId: string, Password: string) => {
    return new Promise((resolve, reject) => {
        const user = new CognitoUser({
            Username: "+1" + userId,
            Pool: userpool
        });

        const authDetails = new AuthenticationDetails({
            Username: "+1" + userId,
            Password
        });

        user.authenticateUser(authDetails, {
            onSuccess: (result) => {
                user.getUserAttributes((err, attributes) => {
                    if (err) {

                    } else {
                        attributes?.map((attr) => {
                            if (attr.getName() === 'custom:user_type') {
                                setAuth({ user_type: attr.getValue() } as any);
                            } else if (attr.getName() === 'email_verified') {
                                setAuth({ email_verified: attr.getValue() } as any);
                            } else if (attr.getName() === 'phone_number_verified') {
                                setAuth({ phone_number_verified: attr.getValue() } as any);
                            } else if (attr.getName() === 'custom:role') {
                                setAuth({ role: attr.getValue() } as any);
                            } else if (attr.getName() === 'custom:requests') {
                                setAuth({ requests: attr.getValue() } as any);
                            }
                        });
                    }
                });
                setAuth({
                    userId: "+1" + userId, name: result.getIdToken().payload.name,
                    accessToken: result.getAccessToken().getJwtToken(),
                    idToken: result.getIdToken().getJwtToken(),
                    refreshToken: result.getRefreshToken().getToken(),
                    expiry: result.getAccessToken().getExpiration() * 1000,
                    refreshExpiry: result.getAccessToken().getExpiration() * 1000 + 3600000
                } as any);
                resolve(result);
            },
            onFailure: (err) => {
                reject(err);
            },
            newPasswordRequired: () => {
                user.completeNewPasswordChallenge(Password, null, {
                    onFailure: (err: any) => {
                        reject(err);
                    },
                    onSuccess: (result: any) => {
                        resolve(result);
                    }
                });
            }
        });
    });
};

export const signInWithGoogle = () => {
    const domain = "login.stafflows.com";
    const clientId = businesspool.getClientId();
    const redirectUri = 'http'+(window.location.host==='localhost:3000'?'':'s')+'://' + window.location.host + '/auth/callback';

    const hostedUiUrl =
        `https://${domain}/oauth2/authorize` +
        `?identity_provider=Google` +
        `&redirect_uri=${redirectUri}` +
        `&response_type=CODE` +
        `&client_id=${clientId}` +
        `&scope=openid%20email%20profile%20aws.cognito.signin.user.admin`;

    window.location.href = hostedUiUrl;
};

export const handleGoogleCallback = (authCode: string) => {
    return new Promise((resolve, reject) => {
        const domain = "login.stafflows.com";
        const clientId = businesspool.getClientId();

        // No encodeURIComponent here - URLSearchParams handles encoding automatically
        const redirectUri = 'http'+(window.location.host==='localhost:3000'?'':'s')+'://' + window.location.host + '/auth/callback';

        const tokenEndpoint = `https://${domain}/oauth2/token`;

        const params = new URLSearchParams({
            grant_type: 'authorization_code',
            client_id: clientId,
            code: authCode,
            redirect_uri: redirectUri  // plain string, not encoded
        });

        fetch(tokenEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: params.toString()
        })
            .then(response => {
                if (!response.ok) {
                    // Log the actual error body for better debugging
                    return response.text().then(text => {
                        throw new Error(`Token exchange failed: ${text}`);
                    });
                }
                return response.json();
            })
            .then(data => {
                const { access_token, id_token, refresh_token } = data;
                const decodedIdToken = JSON.parse(atob(id_token.split('.')[1]));

                setAuth({
                    userId: decodedIdToken.sub,
                    name: decodedIdToken.name || decodedIdToken['cognito:username'],
                    email: decodedIdToken.email,
                    accessToken: access_token,
                    idToken: id_token,
                    refreshToken: refresh_token,
                    expiry: Date.now() + (data.expires_in * 1000),
                    refreshExpiry: Date.now() + ((data.expires_in + 3600) * 1000)
                } as any);

                resolve(data);
            })
            .catch(error => {
                console.error('Error exchanging authorization code for tokens:', error);
                reject(error);
            });
    });
};

export const signUpBusiness = (name: string, email: string, password: string) => {
    const attributes = [
        new CognitoUserAttribute({
            Name: 'name',
            Value: name
        }),
        new CognitoUserAttribute({
            Name: 'email',
            Value: email
        }),
        new CognitoUserAttribute({
            Name: 'custom:user_type',
            Value: ''
        }),
        new CognitoUserAttribute({
            Name: 'custom:role',
            Value: 'admin'
        }),
    ];

    return new Promise((resolve, reject) => {
        businesspool.signUp(email, password, attributes, [], (err: any, result: unknown) => {
            if (err) {
                reject(err);
            }
            else {
                resolve(result);
            }
        });
    });
}

export const signUpUser = (name: string, phone: string, password: string, ownerId: string, scheduleId: string) => {
    const attributes = [
        new CognitoUserAttribute({
            Name: 'name',
            Value: name
        }),
        new CognitoUserAttribute({
            Name: 'phone_number',
            Value: "+1" + phone
        }),
        new CognitoUserAttribute({
            Name: 'custom:user_type',
            Value: ''
        }),
        new CognitoUserAttribute({
            Name: 'custom:role',
            Value: 'staff'
        }),
        new CognitoUserAttribute({
            Name: 'custom:requests',
            Value: ownerId + "#" + scheduleId
        }),
    ];

    return new Promise((resolve, reject) => {
        userpool.signUp("+1" + phone, password, attributes, [], (err: any, result: unknown) => {
            if (err) {
                reject(err);
            }
            else {
                resolve(result);
            }
        });
    });
}

export const confirmRegistrationBusiness = (code: string, userId: string) => {
    return new Promise((resolve, reject) => {
        const user = new CognitoUser({
            Username: userId,
            Pool: businesspool
        });

        user.confirmRegistration(code, true, (err, result) => {
            if (err) {
                reject(err);
            }
            else {
                resolve(result);
            }
        });
    });
}

export const confirmRegistrationUser = (code: string, userId: string) => {
    return new Promise((resolve, reject) => {
        const user = new CognitoUser({
            Username: userId,
            Pool: userpool
        });

        user.confirmRegistration(code, true, (err, result) => {
            if (err) {
                reject(err);
            }
            else {
                resolve(result);
            }
        });
    });
}

export const resendConfirmationCodeBusiness = (email: string) => {
    return new Promise((resolve, reject) => {
        const user = new CognitoUser({
            Username: email,
            Pool: businesspool
        });

        user.resendConfirmationCode((err, result) => {
            if (err) {
                reject(err);
            }
            else {
                resolve(result);
            }
        });
    });
}

export const resendConfirmationCodeUsers = (phone_number: string) => {
    return new Promise((resolve, reject) => {
        const user = new CognitoUser({
            Username: phone_number,
            Pool: userpool
        });

        user.resendConfirmationCode((err, result) => {
            if (err) {
                reject(err);
            }
            else {
                resolve(result);
            }
        });
    });
}

export const logout = () => {
    const user = getUserPool()!.getCurrentUser();
    // clear in-memory auth
    clearAuth();
    user?.signOut();
    window.location.href = '/login';
};

export const refreshUserSession = () => {
    return new Promise((resolve, reject) => {
        const userPool = getUserPool();

        if (!userPool) {
            reject(new Error('No user currently logged in.'));
            return;
        }

        const user = userPool.getCurrentUser()!;

        const refreshTokenValue = getAuth().refreshToken;
        if (!refreshTokenValue) {
            reject(new Error('No refresh token available.'));
            return;
        }

        const refreshToken = new CognitoRefreshToken({ RefreshToken: refreshTokenValue });

        user.refreshSession(refreshToken, (err, session: CognitoUserSession) => {
            if (err) {
                reject(err);
            } else {
                // Update in-memory tokens
                setAuth({
                    accessToken: session.getAccessToken().getJwtToken(),
                    idToken: session.getIdToken().getJwtToken(),
                    expiry: session.getAccessToken().getExpiration() * 1000
                } as any);

                resolve(session);
            }
        });
    });
};

export const changePassword = (oldPassword: string, newPassword: string) => {
    return new Promise((resolve, reject) => {
        const userPool = getUserPool();

        if (!userPool) {
            reject(new Error('No user currently logged in.'));
            return;
        }

        const user = userPool.getCurrentUser();

        if (!user) {
            reject(new Error('No user currently logged in.'));
            return;
        }

        user.getSession((err: any, session: CognitoUserSession | null) => {
            if (err) {
                reject(err);
                return;
            }

            if (!session || !session.isValid()) {
                reject(new Error('Invalid session. Please log in again.'));
                return;
            }

            user.changePassword(oldPassword, newPassword, (err, result) => {
                if (err) {
                    reject(err);
                } else {
                    resolve(result);
                }
            });
        });
    });
};

export const forgotPassword = (username: string, isBusinessUser: boolean = false) => {
    return new Promise((resolve, reject) => {
        const pool = isBusinessUser ? businesspool : userpool;
        const formattedUsername = isBusinessUser ? username : "+1" + username;

        const user = new CognitoUser({
            Username: formattedUsername,
            Pool: pool
        });

        user.forgotPassword({
            onSuccess: (result) => {
                resolve(result);
            },
            onFailure: (err) => {
                reject(err);
            }
        });
    });
};

export const confirmPasswordReset = (username: string, confirmationCode: string, newPassword: string, isBusinessUser: boolean = false) => {
    return new Promise((resolve, reject) => {
        const pool = isBusinessUser ? businesspool : userpool;
        const formattedUsername = isBusinessUser ? username : "+1" + username;

        const user = new CognitoUser({
            Username: formattedUsername,
            Pool: pool
        });

        user.confirmPassword(confirmationCode, newPassword, {
            onSuccess: (result) => {
                resolve(result);
            },
            onFailure: (err) => {
                reject(err);
            }
        });
    });
};

export const updateUserAttribute = (attributeName: string, attributeValue: string) => {
    return new Promise((resolve, reject) => {
        const userPool = getUserPool();

        if (!userPool) {
            reject(new Error('No user currently logged in.'));
            return;
        }

        const user = userPool.getCurrentUser();

        if (!user) {
            reject(new Error('No user currently logged in.'));
            return;
        }

        user.getSession((err: any, session: CognitoUserSession | null) => {
            if (err) {
                reject(err);
                return;
            }

            if (!session || !session.isValid()) {
                reject(new Error('Invalid session. Please log in again.'));
                return;
            }

            const attributeList = [
                new CognitoUserAttribute({
                    Name: attributeName,
                    Value: attributeValue
                })
            ];

            user.updateAttributes(attributeList, (err, result) => {
                if (err) {
                    reject(err);
                } else {
                    resolve(result);
                }
            });
        });
    });
};

export const verifyUserAttribute = (attributeName: 'email' | 'phone_number', verificationCode: string) => {
    return new Promise((resolve, reject) => {
        const userPool = getUserPool();

        if (!userPool) {
            reject(new Error('No user currently logged in.'));
            return;
        }

        const user = userPool.getCurrentUser();

        if (!user) {
            reject(new Error('No user currently logged in.'));
            return;
        }

        user.getSession((err: any, session: CognitoUserSession | null) => {
            if (err) {
                reject(err);
                return;
            }

            if (!session || !session.isValid()) {
                reject(new Error('Invalid session. Please log in again.'));
                return;
            }

            user.verifyAttribute(attributeName, verificationCode, {
                onSuccess: (result: any) => {
                    if (attributeName === 'email') {
                        setAuth({ email_verified: 'true' } as any);
                    } else if (attributeName === 'phone_number') {
                        setAuth({ phone_number_verified: 'true' } as any);
                    }
                    resolve(result);
                },
                onFailure: (err: any) => {
                    reject(err);
                }
            });
        });
    });
};

export const getAttributeVerificationCode = (attributeName: 'email' | 'phone_number') => {
    return new Promise((resolve, reject) => {
        const userPool = getUserPool();

        if (!userPool) {
            reject(new Error('No user currently logged in.'));
            return;
        }

        const user = userPool.getCurrentUser();

        if (!user) {
            reject(new Error('No user currently logged in.'));
            return;
        }

        user.getSession((err: any, session: CognitoUserSession | null) => {
            if (err) {
                reject(err);
                return;
            }

            if (!session || !session.isValid()) {
                reject(new Error('Invalid session. Please log in again.'));
                return;
            }

            user.getAttributeVerificationCode(attributeName, {
                onSuccess: (result: any) => {
                    resolve(result);
                },
                onFailure: (err: any) => {
                    reject(err);
                }
            });
        });
    });
};